import React from "react";
import { Grid } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import {
  RESET_STATE_FORM_FILTER,
  getAllLaporanPembelianFarmasiExport,
} from "./helpers";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../PembelianWMS/helpers";

export default function FormFilterDaftarPO({
  formFilter,
  setFormFilter,
  setNewData,
  resetPagination,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData(1, 10);
    resetPagination();
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudangUtama,
    TYPE_INSTANCE4
  );

  const supplier = useInitialMasterSupplier(
    true,
    LIST_URL_WAREHOUSE.masterSupplier.getByPo
  );

  const handleExportAll = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const res = await getAllLaporanPembelianFarmasiExport(formFilter);
    if (res.state) {
      defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...");
    } else {
      defaultToastError(res.message);
    }
    setIsLoading(false);
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item sm={6}>
                <InputOptionMaster
                  name='gudang_id'
                  label='GUDANG UTAMA MEDIS'
                  id='gudang_id'
                  withSearch={true}
                  data={gudangUtama}
                  value={formFilter.gudang_id}
                  labelValue={formFilter.gudang}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      gudang_id: e?.value,
                      gudang: e?.label,
                    })
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <InputOptionMaster
                  name='is_PO'
                  label='KATEGORI PEMBELIAN'
                  id='is_PO'
                  value={formFilter.is_PO}
                  onChange={handleChange("is_PO")}
                  data={[
                    {
                      value: "",
                      label: "Semua",
                    },
                    {
                      value: 1,
                      label: "Dengan PO",
                    },
                    {
                      value: 0,
                      label: "Tanpa PO",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name='id'
                  label='ID Pembelian'
                  id='id'
                  value={formFilter.id}
                  onChange={handleChange("id")}
                  placeholder='ID Pembelian'
                />
              </Grid>

              <Grid item xs={3}>
                <InputOptionMaster
                  name='status'
                  label='STATUS'
                  id='status'
                  value={formFilter.status}
                  onChange={handleChange("status")}
                  data={[
                    {
                      value: "",
                      label: "Semua",
                    },
                    {
                      value: STATUS_OPEN_DRAFT_PEMBELIAN,
                      label: "Draft",
                    },
                    {
                      value: STATUS_PROSES_PEMBELIAN,
                      label: "Tutup",
                    },
                    {
                      value: STATUS_SELESAI_PEMBELIAN,
                      label: "Terproses",
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={3}>
                <InputOptionMaster
                  name='lunas'
                  label='STATUS PEMBAYARAN'
                  id='lunas'
                  value={formFilter.lunas}
                  onChange={handleChange("lunas")}
                  data={[
                    {
                      value: 0,
                      label: "Semua",
                    },
                    {
                      value: 1,
                      label: "Lunas",
                    },
                    {
                      value: 2,
                      label: "Belum Lunas",
                    },
                  ]}
                />
              </Grid>

              <Grid item xs={3}>
                <InputOptionMaster
                  name='kategory_tanggal'
                  label='KATEGORI TANGGAL PENCARIAN'
                  id='kategory_tanggal'
                  value={formFilter.kategory_tanggal}
                  needParse={false}
                  onChange={handleChange("kategory_tanggal")}
                  data={[
                    {
                      value: "tanggal pembelian",
                      label: "Tanggal Pembelian",
                    },
                    {
                      value: "faktur",
                      label: "Faktur",
                    },
                    {
                      value: "jatuh tempo",
                      label: "Jatuh Tempo",
                    },
                    {
                      value: "tagih",
                      label: "Tagih",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name='no_faktur'
                  label='NO FAKTUR'
                  id='no_faktur'
                  value={formFilter.no_faktur}
                  onChange={handleChange("no_faktur")}
                  placeholder='No Faktur'
                />
              </Grid>
              <Grid item sm={3}>
                <InputOptionMaster
                  name='supplier_id'
                  label='SUPPLIER'
                  id='supplier_id'
                  withSearch={true}
                  data={supplier}
                  value={formFilter.supplier_id}
                  labelValue={formFilter.supplier}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      supplier_id: e?.value,
                      supplier: e?.label,
                    })
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputReactDatepicker
                  selected={formFilter.tanggal_awal}
                  label='TANGGAL AWAL'
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <InputReactDatepicker
                  selected={formFilter.tanggal_akhir}
                  label='TANGGAL AKHIR'
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}>
            <MasterButton
              type={"button"}
              color='primary-cyan'
              name={"Export List"}
              size='md'
              onClick={() => setShowModalExportList(!showModalExportList)}
            />
            <MasterButton
              type={"button"}
              color='warning'
              name={isLoading ? "Loading..." : "EXPORT"}
              disabled={isLoading}
              size='md'
              onClick={handleExportAll}
            />
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              type={"submit"}
              size={"md"}
            />
          </div>
        </Grid>
        <br />
      </form>
      {showModalExportList && (
        <ModalExportList
          title={"Daftar Export List Daftar Pembelian Perbekalan Farmasi"}
          showModal={() => setShowModalExportList(false)}
          type={"daftarPembelianFarmasi"}
        />
      )}
    </>
  );
}
